import type * as React from "react";

import { cn } from "./lib/utils";

function Textarea({
	className,
	variant,
	...props
}: React.ComponentProps<"textarea"> & {
	variant?: "default" | "error" | "success";
}) {
	return (
		<textarea
			data-slot="textarea"
			className={cn(
				"border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
				variant === "error" &&
					"border-destructive focus-visible:border-destructive focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40",
				variant === "success" &&
					"border-green-500 focus-visible:border-green-500 focus-visible:ring-green-500/20",
				className,
			)}
			{...props}
		/>
	);
}

export { Textarea };
